import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=775d19fc&scoped=true&lang=pug&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=775d19fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d19fc",
  null
  
)

export default component.exports